shadow$provide[122] = function(require,module,exports) {
var require$_DOT__DOT__SLASH_bootstrap = require("../bootstrap");
require$_DOT__DOT__SLASH_bootstrap.Bootstrap.registerPlugin("ui", {defaults:{theme:"white", style:".threestrap-ui { position: absolute; bottom: 5px; right: 5px; float: left; }" + ".threestrap-ui button { border: 0; background: none;" + "  vertical-align: middle; font-weight: bold; } " + ".threestrap-ui .glyphicon { top: 2px; font-weight: bold; } " + "@media (max-width: 640px) { .threestrap-ui button { font-size: 120% } }" + ".threestrap-white button { color: #fff; text-shadow: 0 1px 1px rgba(0, 0, 0, 1), " + 
"0 1px 3px rgba(0, 0, 0, 1); }" + ".threestrap-black button { color: #000; text-shadow: 0 0px 1px rgba(255, 255, 255, 1), " + "0 0px 2px rgba(255, 255, 255, 1), " + "0 0px 2px rgba(255, 255, 255, 1) }",}, listen:["fullscreen"], markup:function(three, theme, style) {
  let url = "//netdna.bootstrapcdn.com/bootstrap/3.0.0/css/bootstrap-glyphicons.css";
  if (location.href.match(/^file:\/\//)) {
    url = "http://" + url;
  }
  const buttons = [];
  if (three.Fullscreen) {
    buttons.push('\x3cbutton class\x3d"fullscreen" title\x3d"Full Screen"\x3e' + '\x3cspan class\x3d"glyphicon glyphicon-fullscreen"\x3e\x3c/span\x3e' + "\x3c/button\x3e");
  }
  if (three.VR) {
    buttons.push('\x3cbutton class\x3d"vr" title\x3d"VR Headset"\x3eVR\x3c/button\x3e');
  }
  return '\x3cstyle type\x3d"text/css"\x3e@import url("' + url + '"); ' + style + "\x3c/style\x3e" + '\x3cdiv class\x3d"threestrap-ui threestrap-' + theme + '"\x3e' + buttons.join("\n") + "\x3c/div\x3e";
}, install:function(three) {
  const ui = this.ui = document.createElement("div");
  ui.innerHTML = this.markup(three, this.options.theme, this.options.style);
  document.body.appendChild(ui);
  const fullscreen = this.ui.fullscreen = ui.querySelector("button.fullscreen");
  if (fullscreen) {
    three.bind([fullscreen, "click:goFullscreen"], this);
  }
  const vr = this.ui.vr = ui.querySelector("button.vr");
  if (vr && three.VR) {
    three.VR.set({mode:"2d"});
    three.bind([vr, "click:goVR"], this);
  }
}, fullscreen:function(event, three) {
  this.ui.style.display = event.active ? "none" : "block";
  if (!event.active) {
    three.VR && three.VR.set({mode:"2d"});
  }
}, goFullscreen:function(event, three) {
  if (three.Fullscreen) {
    three.Fullscreen.toggle();
  }
}, goVR:function(event, three) {
  if (three.VR) {
    three.VR.set({mode:"auto"});
    three.Fullscreen.toggle();
  }
}, uninstall:function(_three) {
  document.body.removeChild(this.ui);
},});

};